import { IconButton, InputAdornment, TextField } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";

/**
 * Controlled search input with a clear button.
 *
 * Props:
 *   value       - current search string
 *   onChange    - callback(newValue: string)
 *   placeholder - input placeholder text
 */
const SearchBar = ({ value, onChange, placeholder = "Search..." }) => (
  <TextField
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    size="small"
    sx={{ mb: 2, width: { xs: "100%", sm: 320 } }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchRoundedIcon fontSize="small" />
        </InputAdornment>
      ),
      endAdornment: value ? (
        <InputAdornment position="end">
          <IconButton
            aria-label="clear search"
            size="small"
            edge="end"
            onClick={() => onChange("")}
          >
            <ClearRoundedIcon fontSize="small" />
          </IconButton>
        </InputAdornment>
      ) : null,
    }}
  />
);

export default SearchBar;
